import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {

  private inputElement: ElementRef;

  private keys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'];

  constructor(public element: ElementRef) {
    this.inputElement = element.nativeElement;
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent) {
    e.preventDefault();
    document.execCommand('insertText', false, '');
  }

  @HostListener('drop', ['$event'])
  onDrop(e: DragEvent) {
    e.preventDefault();
    document.execCommand('insertText', false, '');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (this.keys.indexOf(e.key) > -1)
      return;

    if (e.metaKey === true || e.ctrlKey === true) {
      switch (e.key) {
        case 'a':
        case 'c':
        case 'v':
        case 'x':
          return;
      }
    }

    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105))
      e.preventDefault();
  }

}
